export const environment = {
  production: true,
  apiUrl: 'https://api.salis.ae/api',
};
